import React from 'react';
import PropTypes from 'prop-types';

const MinusIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 10 2">
        <rect width="2" height="10" rx="1" transform="rotate(90 5 5)" fill={fill} />
    </svg>
);

MinusIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

MinusIcon.defaultProps = {
    width: '10',
    height: '2',
    fill: '#707070'
};

export default MinusIcon;
